module.exports = __webpack_public_path__ + "img/donante-gandhi.59dcace7.png";